import React from 'react';

import { LoginCredentials } from 'pages/Settings/SettingsPage/SettingsAccount/LoginCredentials';
import { AccountInformation } from 'pages/Settings/SettingsPage/SettingsAccount/AccountInformation';
import { SettingsPageStyle } from 'styles/pages/settings.styles';
import { GetUserQuery } from 'data/__generated__';

export const SettingsPageAccount: React.FC<{ user: GetUserQuery['user'] }> = ({ user }) => {
    return (
        <SettingsPageStyle>
            <AccountInformation user={user} />
            <LoginCredentials username={user?.username} />
        </SettingsPageStyle>
    );
};
